<template>
  <Layout>
    <div class="store mb-5">
      <div class="bg-white">
        <div class="container">
          <div class="global-slider">
            <div class="slider">
              <carousel
                :autoplay="true"
                :perPage="1"
                :paginationEnabled="false"
              >
                <slide v-for="slide in slides" :key="slide.id">
                  <div class="slide-image">
                    <img :src="slide.img" />
                  </div>
                </slide>
              </carousel>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-8 col-12">
              <div class="search-store">
                <div class="wrapper-search">
                  <input
                    type="text"
                    placeholder="Cari Program ..."
                    class="form-control"
                    v-model="filterSearch"
                    v-on:keyup.enter="appliedSearch"
                  />
                  <div class="btn-group-search">
                    <a
                      href="javascript:void(0)"
                      type="button"
                      class="btn btn-search left"
                      @click="appliedSearch"
                    >
                      <img
                        src="/img/search.png"
                        class="icon-search"
                      />
                    </a>
                    <a
                      href="javascript:void(0)"
                      type="button"
                      class="btn btn-search right filter-box-btn"
                      @click="toggleOpen(isShow)"
                    >
                      <img
                        src="/img/filter.png"
                        class="icon-search"
                      />
                      <span class="countApplied">{{
                        filterApplied
                      }}</span>
                    </a>
                  </div>
                </div>

                <div v-if="isShow" class="filter-block shadow-sm">
                  <div class="filter">
                    <div class="row">
                      <div class="col-4">
                        <div class="value">
                          <a href="javascript:void(0)"> Tipe </a>
                          <ul>
                            <li
                              v-for="ziswaf in kategoriZiswaf"
                              :key="ziswaf.code"
                            >
                              <label>
                                <input
                                  type="checkbox"
                                  name="tipe"
                                  v-model="filterTipe"
                                  :value="ziswaf.code"
                                />
                                <span>{{ ziswaf.name }}</span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="value">
                          <a href="javascript:void(0)"> Mitra </a>
                          <ul v-if="kategoriMitra.length > 0">
                            <li
                              v-for="mitra in kategoriMitra"
                              :key="mitra.code"
                            >
                              <label>
                                <input
                                  type="checkbox"
                                  name="tipe"
                                  v-model="filterMitra"
                                  :value="mitra.kode"
                                />
                                <span>{{ mitra.name }}</span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="value">
                          <a href="javascript:void(0)"> Lembaga </a>
                          <ul v-if="kategoriLembaga.length > 0">
                            <li
                              v-for="lembaga in kategoriLembaga"
                              :key="lembaga.code"
                            >
                              <label>
                                <input
                                  type="checkbox"
                                  name="tipe"
                                  v-model="filterLembaga"
                                  :value="lembaga.code"
                                />
                                <span>{{ lembaga.name }}</span>
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filter-button">
                    <button class="btn btn-main" @click="resetData">
                      Reset
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="toggleOpen(true)"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <template v-if="dataLoader">
              <div
                v-for="row in skeletonCount"
                :key="row.id"
                class="col-xl-3 col-md-6 col-sm-12"
              >
                <skeleton-card></skeleton-card>
              </div>
            </template>
            <template v-else>
              <!-- nodata -->
              <template v-if="data.length < 1">
                <div class="col-12">
                  <div class="alert-warning nodata">No Data.</div>
                </div>
              </template>
              <!-- data exists -->
              <template v-else>
                <div
                  v-for="row in data"
                  :key="row.id"
                  class="col-xl-3 col-md-6 col-sm-12"
                >
                  <card :data="row"></card>
                </div>
              </template>
            </template>
          </div>

          <div class="row mt-5">
            <div class="col-12 text-center">
              <a
                href="javascript:void(0)"
                class="btn btn-main"
                @click="loadMore"
                >More</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../views/layouts/Index.vue';
import { Carousel, Slide } from 'vue-carousel';
import loadApi from '../../utils/masjedapi';
import axios from 'axios';
import Card from './component/card.vue';
import SkeletonCard from './component/skeletoncard.vue';

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Card,
    SkeletonCard,
  },
  data() {
    return {
      isShow: false,
      slides: [],
      dataLoader: false,
      data: [],
      kategoriMitra: [],
      kategoriLembaga: [],
      kategoriZiswaf: [
        {
          code: 'INFAQ',
          name: 'INFAQ',
        },
        {
          code: 'ZAKAT',
          name: 'ZAKAT',
        },
        {
          code: 'SEDEKAH',
          name: 'SEDEKAH',
        },
        {
          code: 'KURBAN',
          name: 'KURBAN',
        },
        {
          code: 'WAKAF',
          name: 'WAKAF',
        },
      ],
      // Filter
      filterSearch: '',
      filterTipe: [],
      filterMitra: [],
      filterLembaga: [],

      page: 1,

      skeletonCount: 12,
    };
  },
  created() {
    this.fetchSlide();
    this.fetchData();
    this.fetchMitra();
    this.fetchLembaga();
  },
  methods: {
    toggleOpen(isShow) {
      this.isShow = !isShow;
    },
    resetData() {
      this.filterTipe = [];
      this.filterMitra = [];
      this.filterLembaga = [];
    },
    async fetchMitra() {
      const mitra = await loadApi.get(`/store/mitra`);
      const { data } = mitra.data;
      this.kategoriMitra = data;
    },
    async fetchLembaga() {
      const lembaga = await loadApi.get(`/store/lembaga`);
      const { data } = lembaga.data;
      this.kategoriLembaga = data;
    },
    async fetchSlide() {
      const slides = await loadApi.get(`/store/slide`);
      const { data } = slides.data;
      this.slides = data;
    },
    async appliedSearch() {
      this.data = [];
      this.page = 1;
      this.toggleOpen(true);
      this.fetchData();
    },
    async loadMore() {
      this.page = this.page + 1;
      this.fetchData();
    },
    async fetchData() {
      this.dataLoader = true;
      let url = new URL('https://api.masjed.id/store/semua');
      // let url = new URL("http://localhost:8000/store/semua");

      if (this.page > 1) url.searchParams.append('page', this.page);

      if (this.filterSearch != '')
        url.searchParams.append('search', this.filterSearch);

      if (this.filterTipe.length > 0)
        url.searchParams.append('tipe', this.filterTipe.join(','));

      if (this.filterMitra.length > 0)
        url.searchParams.append('mitra', this.filterMitra.join(','));

      if (this.filterLembaga.length > 0)
        url.searchParams.append(
          'lembaga',
          this.filterLembaga.join(',')
        );

      const terbaru = await axios.get(url);
      const { data } = terbaru.data;
      if (data.length > 0) {
        this.skeletonCount = this.skeletonCount + 12;
        data.map((item) => {
          this.data.push(item);
        });
      } else {
        this.page = this.page - 1;
      }

      this.dataLoader = false;
    },
  },
  computed: {
    filterApplied() {
      return (
        this.filterTipe.length +
        this.filterMitra.length +
        this.filterLembaga.length
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-search {
  width: 18px;
}

.filter-box-btn {
  display: block;
  position: relative;
  .countApplied {
    display: inline-block;
    margin-left: 5px;
  }
}
</style>
